import { callApiWithAuthorization } from "../CallApi";

export async function getCompressedJson(
    projectId,
    organizationId,
    publisherId,
    instanceId,
    forPreview,
    forImport
) {
    try {
        const request = await callApiWithAuthorization(
            "/api/v0/project/" + projectId + "/compressedJson",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    projectId,
                    organizationId,
                    publisherId,
                    instanceId,
                    forPreview,
                    forImport
                }),
            }
        );
        const response = await request.blob();
        return response;
    } catch (e) {
        return e.message;
    }
}

export async function getRawJson(
    projectId,
    organizationId,
    publisherId,
    instanceId,
    forPreview,
    forImport
) {
    try {
        const request = await callApiWithAuthorization(
            "/api/v0/getJsonData/" + projectId,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    projectId,
                    organizationId,
                    publisherId,
                    instanceId,
                    forPreview,
                    forImport
                }),
            }
        );
        const response = await request.json();
        return response;
    } catch (e) {
        return e.message;
    }
}
